<template>
    <div>
        <div class="content-box account-info first">
            <el-alert v-if="errorMessage" style="margin-bottom: 20px" title="姓名修改失败" :closable="false" type="error" show-icon>
                {{ errorMessage }}
                <br />
                尝试
                <span class="important" @click="displayQrCode()">人脸识别</span>
                进行实名认证
            </el-alert>
            <el-form :model="formData" ref="formData" label-width="150px">
                <el-form-item
                    label="现用名"
                    prop="personName"
                    :rules="[
                        {required: true, message: '请输入现用名', trigger: 'blur'},
                        {regexp: /^[\u4e00-\u9fa5]{2,6}$/, message: '字数范围在2~6个，只能输入中文'},
                        {
                            validator: (rule, value, callback) => {
                                if (value === oldUserData.adminUserName) {
                                    callback('与当前姓名一致，请重新输入');
                                } else {
                                    callback();
                                }
                            },
                        },
                    ]"
                >
                    <el-input placeholder="请输入更改后的姓名" min="2" max="6" v-model="formData.personName"></el-input>
                </el-form-item>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :rules="[{required: true, message: '请上传证件正面'}]" prop="personIdCardFrontFile" label="证件正面">
                            <ImageUpload
                                :size="10"
                                fixedNumber="4:3"
                                :url.sync="formData.personIdCardFrontFile"
                                accept="image/png,image/jpeg"
                                @onSuccess="handlepersonIdCardFrontFileSuccess"
                            >
                                <div slot="tips">格式JPG、JPEG、PNG，不得大于10M</div>
                            </ImageUpload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{required: true, message: '请上传证件背面'}]" prop="personIdCardBackFile" label="证件背面">
                            <ImageUpload
                                :size="10"
                                :url.sync="formData.personIdCardBackFile"
                                fixedNumber="4:3"
                                accept="image/png,image/jpeg"
                                @onSuccess="handlepersonIdCardFrontFileSuccess"
                            >
                                <div slot="tips">格式JPG、JPEG、PNG，不得大于10M</div>
                            </ImageUpload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="tips" style="padding-left: 150px; font-size: 12px; color: #666; margin-bottom: 30px">
                    1. 认证人必须年满18岁
                    <br />
                    2. 请上传本人清晰彩色完整的证件原件；
                    <br />
                    3. 照片应清晰可见容易识别，且边框完整；
                    <br />
                    4. 必须真实拍摄，不能使用复印件；
                    <br />
                    5. 仅支持 png、jpg、jpeg，大小不超过 10M
                    <br />
                    6.请上传姓名更正后的身份证
                </div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            prop="personIdCard"
                            :rules="[
                                {required: true, message: '请输入身份证号', trigger: 'blur'},
                                {
                                    validator: (rule, value, callback) => {
                                        if (value.toLowerCase() !== oldUserData.idNum.toLowerCase()) {
                                            callback('与系统保留的身份证号不一致，请重新上传身份证照片');
                                        } else {
                                            callback();
                                        }
                                    },
                                    trigger: ['blur', 'change'],
                                },
                            ]"
                            label="身份证号"
                        >
                            <el-input placeholder="身份证号" disabled v-model="formData.personIdCard"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="认证电话">
                            <el-input placeholder="认证电话" disabled v-model="formData.personMobile"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div style="text-align: center">
                <el-button @click="onColse">取 消</el-button>
                <el-button type="primary" :loading="nextLoading" @click="onNext">下一步</el-button>
            </div>
        </div>
        <el-dialog
            title="人脸识别认证"
            :visible.sync="weixinVisible"
            center
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            width="550px"
        >
            <div class="qr-content">
                <p>
                    将要为
                    <b>{{ formData.personName }} ({{ formData.personMobile }})</b>
                    进行人脸识别
                    <br />
                    请使用微信扫一扫在手机完成认证
                </p>
                <div class="qrcode" ref="qrCode"></div>
            </div>
            <div slot="footer" class="qr-footer">
                <el-button type="primary" :loading="successLoading" icon="el-icon-success">认证中</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import ImageUpload from '@/components/ImageUpload';
import store from '@/store';
export default {
    components: {
        ImageUpload,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            oldUserData: {
                adminUserName: '',
                idName: '',
                telephone: '',
            },
            formData: {
                personName: '',
                personIdCardFrontFile: '',
                personIdCardBackFile: '',
                personIdCard: '',
                personMobile: '',
            },
            errorMessage: '', // 错误的文字描述
            nextLoading: false,
            qrcode: null,
            threeElementsFail: false, // 三要素认证失败
            weixinVisible: false,
            successLoading: false,
        };
    },
    computed: {
        qrUrl() {
            const {personName, personIdCard, personMobile, personIdCardFrontFile, personIdCardBackFile} = this.formData;
            const {sign, config} = this.$store.state;
            if (personName && personIdCard && personMobile && sign && config.cpHomeUrl)
                return `${config.cpHomeUrl}/pages/contract/vefify/dzq/aliveVideo/aliveVideo?verifyName=${encodeURIComponent(
                    personName
                )}&idNum=${personIdCard}&telephone=${personMobile}&sign=${sign}&from=pc&idPhoto=${encodeURIComponent(
                    personIdCardFrontFile
                )}&idPhoto2=${encodeURIComponent(personIdCardBackFile)}&type=2`;
            return '';
        },
    },
    mounted() {
        // this.$dzqToFdd();
        this.getUserInfo();
    },
    methods: {
        handlepersonIdCardFrontFileSuccess() {
            if (this.formData.personIdCardFrontFile && this.formData.personIdCardBackFile) {
                // this.getIDCard();
                this.$refs['formData'].clearValidate('personIdCardFrontFile');
                this.$refs['formData'].clearValidate('personIdCardBackFile');
            }
        },
        // 身份证读取
        async getIDCard() {
            const {personIdCardFrontFile, personIdCardBackFile} = this.formData;
            if (!personIdCardFrontFile || !personIdCardBackFile) return;
            const response = await this.$request({
                url: '/letSign/idCardDiscern',
                method: 'POST',
                formData: false,
                data: {backImage: personIdCardBackFile, frontImage: personIdCardFrontFile},
            });
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            if (result.personName && result.personIdCard) {
                this.formData.personName = result.personName;
                this.formData.personIdCard = result.personIdCard;
            }
        },
        displayQrCode() {
            this.weixinVisible = true;
            this.$nextTick(() => {
                this.creatQrCode();
                this.getStatus();
            });
        },
        // 获取认证状态
        async getStatus() {
            this.successLoading = true;
            const response = await this.$request({
                url: '/org/get/edit/verifyName/stage',
                method: 'GET',
            });
            const {state, result, msg} = response.data;
            if (!state) return this.$message.error(msg || '');
            if (result != 3) {
                await new Promise((resolve) => setTimeout(resolve, 4000));
                this.getStatus();
            } else {
                this.$notify({
                    title: '成功',
                    message: '请注意核对支付宝平台的认证名是否修改，以免出现绑定支付宝账号失败或提现失败的问题。',
                    type: 'success',
                });
                this.$emit('onSuccess', true);
                this.weixinVisible = false;
                this.successLoading = false;
            }
        },
        creatQrCode() {
            if (this.qrcode) {
                this.qrcode.makeCode(this.qrUrl);
            } else {
                this.qrcode = new QRCode(this.$refs.qrCode, {
                    text: this.qrUrl,
                    width: 300,
                    height: 300,
                    colorDark: '#5914ee',
                    colorLight: '#ffffff',
                    correctLevel: 3,
                });
            }
        },
        onColse() {
            this.$router.go(-1);
        },
        // 获取用户信息
        async getUserInfo() {
            this.dataLoading = true;
            const response = await this.$request({
                url: '/org/view/get_identification_information',
                method: 'post',
            });
            const {state, result, msg} = response.data;
            if (!state) return this.$message.error(msg || '');
            const {idNum, telephone} = result;
            if (idNum && telephone) {
                this.oldUserData = result;
                this.formData.personIdCard = idNum;
                this.formData.personMobile = telephone;
            }
            this.formData.personName = result.adminUserName;
            this.formData.personIdCardFrontFile = result.idPhoto;
            this.formData.personIdCardBackFile = result.idPhoto2;
        },
        // 三要素验证
        async realNameVerification() {
            const data = JSON.parse(JSON.stringify(this.formData));
            delete data.personMobile;
            this.nextLoading = true;
            const response = await this.$request({
                url: '/org/edit/verifyName',
                method: 'POST',
                data,
                formData: false,
            });
            const {state, msg, code} = response.data;
            this.nextLoading = false;
            if (!state) {
                if (code === '11006') {
                    this.errorMessage = msg;
                } else {
                    this.$message.error(msg || '');
                }
            } else {
                this.$notify({
                    title: '成功',
                    message: '请注意核对支付宝平台的认证名是否修改，以免出现绑定支付宝账号失败或提现失败的问题。',
                    type: 'success',
                });
                await this.$store.dispatch('getUserInfo');
                this.onColse();
            }
        },
        onNext() {
            this.$refs['formData'].validate(async (valid) => {
                if (!valid) return;
                await this.$dzqToFddNew(2, this.formData.personName);
                //await this.realNameVerification();
            });
        }
    },
};
</script>
<style lang="scss">
.qr-content {
    text-align: center;

    b {
        color: #333;
    }

    .qrcode {
        margin-top: 20px;
        text-align: center;
        display: inline-block;
    }
}
</style>
